import { styled, Tabs, TabsProps, tabsClasses, tabClasses } from '@methanesat/ui-components';

const StyledTabs = styled(({ ...props }: TabsProps) => <Tabs {...props} />)(({ theme }) => ({
    minHeight: 'unset',
    [`& .${tabClasses.root}`]: {
        padding: '4px 12px',
        textTransform: 'none',
        minHeight: 'unset',
        minWidth: 'unset',
        fontSize: 14,
        ':not(:last-child)': {
            borderRight: '1px solid ' + theme.palette.grey[400]
        }
    },
    [`& .${tabsClasses.indicator}`]: {
        backgroundColor: 'transparent',
        backgroundImage:
            'linear-gradient(to right, transparent 10%,' +
            theme.palette.primary.main +
            ' 10%,' +
            theme.palette.primary.main +
            ' 90%, transparent 90%)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '80% 2px',
        backgroundPosition: 'bottom center'
    },
    [`& .${tabClasses.root}:first-of-type`]: {
        paddingLeft: 0
    }
}));

export default StyledTabs;
